var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-layout',{attrs:{"title":_vm.layoutTit}},[_c('div',{staticClass:"login-suc-box"},[_c('i',{staticClass:"icon iconfont icon-unselect suc-ico"}),_c('p',[_vm._v(_vm._s(_vm.$t('message["1566"]')))]),_c('p',[_vm._v(_vm._s(_vm.duration)+_vm._s(_vm.$t('message["641"]'))+"…")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }